{
  "title": "Game lobby",
  "subtitle": "Every game from the Aggregator catalog is available here.",
  "searchPlaceholder": "Search games",
  "history": "Game history",
  "searchResults": "Search",
  "bonusContinueTitle": "Continue with bonus?",
  "bonusContinueBody": "Main balance is 0. You have bonus funds — used only if you choose.",
  "openExternal": "Open game",
  "openExternalHint": "If the game does not load inside the app, open it with the button below.",
  "backToCatalog": "Back to catalog",
  "notFound": "Game not found",
  "categories": "Categories",
  "all": "All",
  "slots": "Slots",
  "live": "Live casino",
  "crash": "Crash",
  "instant": "Instant",
  "table": "Table",
  "other": "Other",
  "popular": "Popular",
  "new": "New",
  "jackpot": "Jackpot",
  "tags": "Quick filters",
  "providers": "Providers",
  "emptyTitle": "Games are not available yet",
  "emptyBody": "The provider catalog has not been synchronized. Real or demo play will activate only after a verified integration.",
  "errorTitle": "Catalog failed to load",
  "errorBody": "Something went wrong while fetching games. Please try again shortly.",
  "notPlayable": "Unavailable right now",
  "demoUnavailable": "Demo is not active yet",
  "realMoneyDisabled": "Real-money gaming is disabled",
  "provider": "Provider",
  "results": "{{count}} games",
  "featured": "Featured",
  "lobbySection": "Catalog",
  "allProviders": "All providers",
  "sort": "Sort",
  "sortRecommended": "Recommended",
  "sortName": "Name",
  "sortProvider": "Provider",
  "favorite": "Favorite",
  "selectWallet": "Choose a balance before you play",
  "realBalance": "Real balance",
  "bonusBalance": "Bonus balance",
  "fundingLocked": "The selected balance stays locked for the whole game session. Real and bonus funds are never combined.",
  "launchPlay": "Play",
  "bonusNotSlot": "Bonus can only be used on verified slot games",
  "bonusPlayDisabled": "Bonus play is not active yet",
  "sessionFundingUnsupported": "The provider cannot safely keep this funding source for the session. This mode was blocked.",
  "loginToPlay": "Sign in to play",
  "sessionLaunched": "Game session created",
  "loadMore": "Show more",
  "loadingMore": "Loading…",
  "showingOf": "{{shown}} / {{total}} games",
  "launchDemo": "PLAY DEMO",
  "launchReal": "PLAY WITH REAL BALANCE",
  "launchBonus": "PLAY WITH BONUS BALANCE",
  "demoLaunched": "Demo session created",
  "recommended": "Recommended",
  "fastGames": "Quick games",
  "bonusWager": "Bonus wager"
}
